import React from "react";
import FloatingCard from "../../../ui/FloatingCard";
import FloatingButton from "../../../ui/FloatingButton";
import StatusBadge from "../../../ui/StatusBadge";
import Matchup, { matchSides } from "../../../ui/Matchup";

const LiveMatchHeader = ({
  isFullPage,
  match,
  isMatchActive,
  onBack,
  onClose,
  sportName,
}) => {
  // Extract league/tournament context from match or match_config
  const p1Name = match.participant_1_name || match.participant1Name || null;
  const p2Name = match.participant_2_name || match.participant2Name || null;
  const participantTitle = p1Name && p2Name ? `${p1Name} vs ${p2Name}` : null;
  const tournamentPrefix = match.tournamentName || match.tournament_name;
  const leagueName = match.leagueName || match.league_name ||
    match.matchConfig?.league_name || match.match_config?.league_name;
  const contextPrefix = tournamentPrefix || leagueName;
  const displayTitle = participantTitle
    ? (contextPrefix ? `${contextPrefix}: ${participantTitle}` : participantTitle)
    : (match.matchName || match.match_name || `Match #${match.match_number || match.id}`);

  return (
    <div className="live-match-header-gaming">
      <FloatingCard variant="primary" size="large" className="delay-1">
        <div className="header-content-gaming">
          <div className="match-info-gaming">
            <div className="match-title-section">
              {isFullPage && (
                <FloatingButton
                  onClick={onBack}
                  variant="secondary"
                  size="small"
                  icon="←"
                >
                  Back
                </FloatingButton>
              )}
              <h1 className="match-title-gaming">
                🎮 {displayTitle}
              </h1>
            </div>
            {p1Name && p2Name && (
              <Matchup
                size="md"
                className="live-match-header__matchup"
                home={matchSides(match)[0]}
                away={matchSides(match)[1]}
              />
            )}
            <div className="match-status-section">
              <StatusBadge status={match.status} kind="match" />
              {isMatchActive && (
                <div className="live-indicator-header">
                  <span className="pulse-dot"></span>
                  🔴 LIVE
                  {sportName && (
                    <span className="live-sport-tag">{sportName}</span>
                  )}
                </div>
              )}
            </div>
          </div>
          {!isFullPage && (
            <FloatingButton
              onClick={onClose}
              variant="danger"
              size="small"
              icon="×"
            >
              Close
            </FloatingButton>
          )}
        </div>
      </FloatingCard>
    </div>
  );
};

export default LiveMatchHeader;
